import { BoxProps, ColorOptions } from '@jfs/ui-new'
import { ViewStyle } from 'react-native'

export const styles = (breakpoint: number) => {
  const isMobile = breakpoint < 660
  return {
    container: {
      position: isMobile ? 'relative' : 'absolute',
      minWidth: isMobile ? 200 : 300,
      minHeight: isMobile ? '100vh' : 0,
      maxHeight: isMobile ? '100vh' : 700,
      top: isMobile ? 0 : 64,
      overflow: isMobile ? 'auto' : 'hidden',
      shadowOffset: { width: 1, height: 1 },
      shadowRadius: 3,
      shadowColor: '#0000001F',
      borderWidth: 1,
      borderColor: '#00000014',
      zIndex: 10,
      // Todo
      backgroundColor: '#FFFFFF',
      borderRadius: isMobile ? 0 : 6,
    } as ViewStyle,
    fixOnMobile: {
      position: isMobile ? 'sticky' : 'relative',
      marginTop: isMobile ? 14 : 0,
      zIndex: 10,
      // Todo
    } as ViewStyle,
    content: {
      paddingVertical: 14,
      borderRadius: isMobile ? 0 : 6,
      // Todo
    } as ViewStyle,
    switch: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      ml: 50,
      pb: 5,
    } as BoxProps,
    subMenuItem: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      // padding: 5,
      paddingVertical: 12,
      paddingHorizontal: 18,
    } as BoxProps,
    subMenu: {
      marginTop: -14,
      backgroundColor: 'WHITE',
      height: '100%',
      borderRadius: 6,
    } as BoxProps,
    cross: {
      marginLeft: 'auto',
      marginRight: 14,
      backgroundColor: 'WHITE',
      padding: 5,
      shadowOffset: { width: 0, height: 2 },
      shadowRadius: 3,
      // Todo
      shadowColor: '#0000001F' as ColorOptions,
      borderRadius: 4,
      zIndex: 4,
    } as BoxProps,
    alert: {
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
    } as BoxProps,
  }
}
